type TSortByName = (
  firstItem: { name: string },
  secondItem: { name: string },
) => number;

export const sortByName: TSortByName = (firstItem, secondItem) =>
  firstItem.name > secondItem.name ? 1 : -1;

export const sortByFieldNameLocaleCompare = (
  data: any[] = [],
  fieldName: string,
  locale: string,
) =>
  data.sort((elemFirst, elemSecond) =>
    (elemFirst[fieldName] as string)?.localeCompare(
      elemSecond[fieldName],
      locale,
    ),
  );
